export class LoadAllCods {
    static readonly type = '[Cods] Load All';
}

export class LazyLoadAllCods {
    static readonly type = '[Cods] Lazy Load All';
}

export class LoadMyCods {
    static readonly type = '[Cods] Load My';
}

export class LazyLoadMyCods {
    static readonly type = '[Cods] Lazy Load My';
}

export class LoadTasks {
    static readonly type = '[Cods] Load Tasks';
}

export class LazyLoadTasks {
    static readonly type = '[Cods] Lazy Load Tasks';
}

export class SetFilter {
    static readonly type = '[Cods] Set Filter';
    constructor(public filter: { [key: string]: string | string[] }) {}
}

export class DeleteCod {
    static readonly type = '[Cods] Delete Cod';
    constructor(public id: string) {}
}
